function AboutUs() {
  return (
    <>
      <div className="container col-xxl-8 px-4 py-5">
        <div className="card container px-4 py-5 my-5 text-center">
          <div>
            <h1 className="display-5 text-primary fw-bold lh-1 mb-3">
              What is The 49 Plan?
            </h1>
            <p className="lead">
              A lot of Mountaineers now live in the other 49 states, but many of
              them still call the Mountain State home. We believe they would
              love to hear some good news from their homeplace. <br />
              <br />
              Young Life in West Virginia has been on the move. The mission
              statement is Introducing adolescents to Jesus Christ and helping
              them grow in their faith. We do this by developing mentor
              relationships with adolescents and offering them programs like YL
              clubs and camping. <br />
              <br /> Young Life is now available for adolescents in 110 WV
              schools in 33 counties, a sevenfold increase in the last 14 years,
              with a prayerful intent to be in every county in the next 7 years.
              Young Life leaders know 11,237 kids by name, which is 7% of
              adolescents in WV. <br />
              <br /> We are in need of prayers, contacts, and funding. <br />
              <br /> Right now a donation of $231 per year delivers all that YL
              offers to a kid. We run lean and raise all operating costs
              locally. As a supplemental source of revenue, we are looking
              outside WV, hoping to find expats who now live in the other 49
              states and want to invest in kids’ futures. <br />
              <br />
              The gap between giving and costs has increased about 1% per year
              over the last 3 years. It takes $2.6M to run YL across WV. Our
              current goal is to raise $100K in supplemental funding from
              49’ers. <br />
              <br /> The 49 Plan will be administrated by YL staff in WV in
              concert with various national YL departments including
              Fundraising, Data, Marketing, and Grants. We also want one
              representative from each county to serve on a 49 Plan steering
              Committee.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default AboutUs;
